window.OpalPeople.module(
  'Components.SettingsEditor',
  function (Module, App, Backbone, Marionette, $, _) {
    var FullModuleName = 'OpalPeople.Components.SettingsEditor'

    var EmailStates = ['disabled', 'individual', 'batch']
    var ScheduleClassPrefix = 'notificationPreferences--schedule-'
    var TimeSelectOptions = Object.freeze({
      hour: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      meridian: ['am', 'pm'],
    })
    var DefaultTime = '09:00'

    function getKeyForNotificationType(model) {
      return model.get('object') + '/' + model.get('action')
    }

    var batchEmailsAllowedKeys = [
      'post/needs_approval',
      'moment/approval_assigned',
    ]
    function isBatchEmailAllowed(model) {
      var key = getKeyForNotificationType(model)
      return batchEmailsAllowedKeys.indexOf(key) > -1
    }

    var groupings = {
      Actions: [
        'asset_reference_zip/asset_reference_zip_complete',
        'csv/csv_export_complete',
        'moment/moment_export_complete',
        'post/share',
        'story/reschedule',
      ],
      Boards: [
        'board/invite_collaborator',
        'board/duplicate',
        'board/moment_added',
        'moment/moment_assignee_assigned',
      ],
      'Chat & Activity': [
        'chat_and_activity/batch_activities',
        'annotation/annotate',
      ],
      Collaboration: [
        'collaboration/thread_created',
        'collaboration/thread_comment_added',
        'collaboration/thread_resolved',
        'collaboration/mention',
      ],
      Content: [
        'post/invite_collaborator',
        'post/native_publishing',
        'post/failed_publishing',
      ],
      'Custom Fields': ['custom_field/moment_people_picker_selected'],
      Localizations: ['post/localization', 'post/styfl10n'],
      Mentions: [
        'chat_and_activity/mention',
        'annotation/mention',
        'post/mention',
        'note/mention',
        'approval/mention',
        'assetreference/mention',
      ],
      Moments: ['moment/invite_collaborator'],
      Stories: ['story/invite_collaborator'],
      Opal: ['opal/send_upcoming'],
      Presentations: [
        'presentation/presentation_complete',
        'presentation/presentation_export_complete',
      ],
      'Workflow on Content': [
        'post/task_assigned',
        'post/needs_completion',
        'post/ready_to_send_approvals',
        'post/needs_approval',
        'post/needs_revision',
        'post/approved',
        'post/integration_task_complete',
      ],
    }

    var workflowOnMomentsGrouping = [
      'moment/approval_assigned',
      'moment/approval_completed',
      'moment/needs_completion',
      'moment/needs_revision',
      'moment/task_assigned',
      'moment/workflow_approved',
      'moment/workflow_paused',
    ]

    function groupForNotificationType(model) {
      var lookupKey = getKeyForNotificationType(model)
      var group = _.findKey(groupings, function (keys) {
        return keys.indexOf(lookupKey) > -1
      })

      if (!group) {
        return null
      }
      return group
    }

    function reformatData(data) {
      var out = data.attributes
      out.id = data.id

      var relations = data.relationships
      if (relations) {
        Object.keys(relations).forEach(function (relationship) {
          out[relationship + '_id'] = relations[relationship].data.id
        })
      }

      return out
    }
    function parseFetch(response) {
      return response.data.map(reformatData)
    }

    Module.NotificationType = Backbone.RelationalModel.extend()
    Module.NotificationTypes = Backbone.Collection.extend({
      model: Module.NotificationType,
      url: function () {
        return '/api/v1/notification_types?user_id=' + this.user.id
      },
      parse: parseFetch,
    })

    Module.NotificationGroup = Backbone.RelationalModel.extend({
      relations: [
        {
          type: Backbone.HasMany,
          key: 'notification_preferences',
          relatedModel: FullModuleName + '.NotificationPreference',
          collectionType: FullModuleName + '.NotificationPreferences',
        },
      ],
    })
    Module.NotificationGroups = Backbone.Collection.extend({
      model: Module.NotificationGroup,
      comparator: function (model) {
        return model.get('name')
      },
    })

    Module.NotificationPreference = Backbone.RelationalModel.extend({
      relations: [
        {
          type: Backbone.HasOne,
          key: 'notification_type',
          keySource: 'notification_type_id',
          keyDestination: 'notification_type',
          relatedModel: FullModuleName + '.NotificationType',
          collectionType: FullModuleName + '.NotificationTypes',
        },
      ],
    })
    Module.NotificationPreferences = Backbone.Collection.extend({
      model: Module.NotificationPreference,
      url: function () {
        return '/api/v1/notification_preferences?user_id=' + this.user.id
      },
      parse: parseFetch,
      comparator: function (model) {
        // The preference may reference a notification type the types endpoint
        // didn't return (e.g. it became hidden after the preference was
        // saved). Sorting must not crash on it.
        var type = model.get('notification_type')
        if (type == null) {
          return ['', '']
        }

        return [type.get('object'), type.get('action')]
      },

      formatForJSONAPI: function () {
        return this.models
          .filter(function (model) {
            return model.get('notification_type') != null
          })
          .map(function (model) {
            var out = {
              type: 'notification_preference',
              attributes: {
                batch_time: model.get('batch_time'),
                batch_timezone: model.get('batch_timezone'),
                in_app_enabled: model.get('in_app_enabled'),
                notification_email_option: model.get(
                  'notification_email_option'
                ),
                notification_type_id: model.get('notification_type').id,
              },
            }

            if (model.id) {
              out.id = model.id
            }

            return out
          })
      },

      // Ignore Backbone's sync implementation.
      syncJSONAPI: function () {
        var formattedData = {
          data: this.formatForJSONAPI(),
        }
        var serialized = JSON.stringify(formattedData)

        var xhr = new XMLHttpRequest()
        xhr.open('POST', _.result(this, 'url'), true)
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.send(serialized)
      },
    })

    function getCollections(user) {
      var groupCollection = new Module.NotificationGroups()
      var preferencesCollection = new Module.NotificationPreferences()
      preferencesCollection.user = user
      var typesCollection = new Module.NotificationTypes()
      typesCollection.user = user

      if (window.Universe.testFeature('workflow_on_moments')) {
        groupings['Workflow on Moments'] = workflowOnMomentsGrouping
      }

      typesCollection
        .fetch({
          reset: true,
        })
        .then(function () {
          return preferencesCollection.fetch({
            reset: true,
          })
        })
        .then(function () {
          var existingIds = preferencesCollection.map(function (model) {
            return model.get('notification_type').id
          })

          // Only use `groupings` keys if at least one of the notification types
          // described in the array is present in `typesCollection`.
          var validGroupings = {}

          // Ensure there's a `NotificationPreference` model for every
          // `NotificationType`. The backend will remove the unnecessary records.
          typesCollection.forEach(function (model) {
            var group = groupForNotificationType(model)
            if (group == null) {
              return
            }
            var groupModel
            if (!validGroupings[group]) {
              groupModel = new Module.NotificationGroup({
                name: group,
              })
              validGroupings[group] = groupModel
            } else {
              groupModel = validGroupings[group]
            }
            var preferenceModel
            if (existingIds.indexOf(model.id) > -1) {
              preferenceModel = preferencesCollection.find(
                function (preferenceModel) {
                  return (
                    preferenceModel.get('notification_type').id === model.id
                  )
                }
              )
            } else {
              var emailDefault
              if (isBatchEmailAllowed(model)) {
                emailDefault = 'individual'
              } else {
                emailDefault = model.get('notification_email_option')
              }

              preferenceModel = new Module.NotificationPreference({
                in_app_enabled: model.get('in_app_enabled'),
                notification_email_option: emailDefault,
                notification_type: model,
                user: user,
              })
              preferencesCollection.add(preferenceModel)
            }

            if (groupModel) {
              groupModel.get('notification_preferences').add(preferenceModel)
            }
          })

          groupCollection.reset(Object.values(validGroupings))
          groupCollection.sort()
        })

      return {
        grouped: groupCollection,
        preferences: preferencesCollection,
        types: typesCollection,
      }
    }

    var container_template = '<div class=js-preferencesWrapper></div>'
    Module.Notifications = App.Views.ModalPane.extend({
      className: 'settings--notifications modal_pane is-loading',
      title: 'Notifications',
      template: _.template(container_template),
      disableTemplateMagic: true,

      modelEvents: {
        sync: 'syncCollection',
      },

      regions: {
        preferences: '.js-preferencesWrapper',
      },

      initialize: function () {
        App.Views.ModalPane.prototype.initialize()

        var user = this.model.get('user')
        this.collections = getCollections(user)

        this.collections.grouped.on(
          'reset',
          function () {
            this.$el.removeClass('is-loading')
          }.bind(this)
        )

        // The modal system assumes this line is present.
        Backbone.Validation.bind(this)
      },

      onRender: function () {
        this.renderPreferences()
      },

      renderPreferences: function () {
        var view = new NotificationPreferencesView({
          collection: this.collections.grouped,
        })
        this.getRegion('preferences').show(view)
      },

      syncCollection: function () {
        this.collections.preferences.syncJSONAPI()
      },
    })

    var model_template =
      "<span class=notificationPreferences--notificationType>\
    <% if (notification_type.humanized_text) { %> \
    <%- notification_type.humanized_text %> \
    <% } else { %> \
    <%= notification_type.action %>, <%= notification_type.object %> \
    <% } %> \
  </span> \
  <% if (notification_type.explanation) { %> \
    <span class=notificationPreferences--explanation><%= notification_type.explanation %></span>\
  <% } %> \
  <div class='notificationPreferences--inApp js-inAppWrapper'></div> \
  <div class='notificationPreferences--email js-emailWrapper'></div> \
  <div class='notificationPreferences--schedule js-schedule'> \
    <div class='notificationPreferences--scheduleBatch js-batchWrapper'></div> \
    <span class=notificationPreferences--scheduleAt>at</span> \
    <div class='notificationPreferences--scheduleHour js-hourWrapper'></div> \
    <div class='notificationPreferences--scheduleMeridian js-meridianWrapper'></div> \
  </div>"
    var PreferenceRow = App.Views.LayoutView.extend({
      className: 'notificationPreferences--notificationPreference',
      tagName: 'li',
      template: _.template(model_template),
      disableTemplateMagic: true,

      ui: {
        batch: '.js-batchWrapper',
        email: '.js-emailWrapper',
        hour: '.js-hourWrapper',
        inApp: '.js-inAppWrapper',
        meridian: '.js-meridianWrapper',
        schedule: '.js-schedule',
      },

      modelEvents: {
        'change notification_email_option': 'updateScheduleVisibility',
      },

      onRender: function () {
        this.renderBatchSelect()
        this.renderEmailToggle()
        this.renderInAppToggle()
        this.renderTimeSelects()
        this.updateScheduleVisibility()
      },

      onBeforeDestroy: function () {
        Object.values(this.ui).forEach(function ($node) {
          if (/Wrapper/.test($node.attr('class'))) {
            window.ReactDOM.unmountComponentAtNode($node.get(0))
          }
        })
      },

      injectDropdown: function ($node, options, selectedOption, callback) {
        var component = window.React.createElement(window.Kuiper.Select, {
          onSelect: function (option) {
            callback.call(this, option)

            this.injectDropdown($node, options, option, callback)
          }.bind(this),
          options: options,
          value: selectedOption,
        })

        window.ReactDOM.unmountComponentAtNode($node.get(0))
        window.ReactDOM.render(component, $node.get(0))
      },

      /**
       * @callback onToggleCallback
       * @param {boolean} isEnabled
       */
      /**
       * @param {JQueryStatic} $node
       * @param {boolean} checked
       * @param {boolean} writeable
       * @param {onToggleCallback} callback - Update appropriate model field.
       */
      injectToggle: function ($node, checked, writeable, callback) {
        var onToggle = function (isEnabled) {
          callback.call(this, isEnabled)

          this.injectToggle($node, isEnabled, writeable, callback)
        }.bind(this)

        var component = window.React.createElement(
          window.Hooks.ThemeProvider,
          {
            theme: 'light',
          },
          window.React.createElement(window.Lapidary.Switch, {
            checked,
            checkedLabel: 'Enabled',
            onToggle,
            readonly: !writeable,
            uncheckedLabel: 'Disabled',
          })
        )

        window.ReactDOM.unmountComponentAtNode($node.get(0))
        window.ReactDOM.render(component, $node.get(0))
      },

      renderBatchSelect: function () {
        var options = [
          {
            id: 'individual',
            title: 'Send email immediately',
          },
          {
            id: 'batch',
            title: 'Send email once daily',
          },
        ]
        var selectedValue = this.model.get('notification_email_option')
        var selectedOption = options.find(function (option) {
          return option.id === selectedValue
        })

        var callback = function (option) {
          var user = this.model.collection.user
          user
            .get('user_settings')
            .set('batch_approval_emails_enabled', option.id === 'batch')
          this.model.set('notification_email_option', option.id)
        }

        this.injectDropdown(this.ui.batch, options, selectedOption, callback)
      },

      renderEmailToggle: function () {
        var type = this.model.get('notification_type')
        var isToggleable = this.model
          .get('notification_type')
          .get('is_email_toggleable')

        var defaultSetting = type.get('notification_email_option')
        if (isBatchEmailAllowed(type)) {
          defaultSetting = 'batch'
        } else if (defaultSetting === 'disabled') {
          defaultSetting = 'individual'
        }

        var setting = this.model.get('notification_email_option')
        var enabled = isToggleable ? setting !== 'disabled' : false

        var callback = function (isEnabled) {
          var newValue
          if (!isEnabled) {
            this.model.set(
              'notification_email_option_was',
              this.model.get('notification_email_option')
            )
            newValue = 'disabled'
          } else {
            // If the user changes the value (e.g. batch to individual), then
            // disables and re-enables emails, restore the value they'd chosen.
            // On the initial render this won't be defined, so fall back to
            // `defaultSetting`.
            newValue =
              this.model.get('notification_email_option_was') || defaultSetting
          }

          this.model.set('notification_email_option', newValue)
        }

        this.injectToggle(this.ui.email, enabled, isToggleable, callback)
      },

      renderInAppToggle: function () {
        var isToggleable = this.model
          .get('notification_type')
          .get('is_in_app_toggleable')
        var enabled = isToggleable ? this.model.get('in_app_enabled') : false

        var callback = function (isEnabled) {
          this.model.set('in_app_enabled', isEnabled)
        }

        this.injectToggle(this.ui.inApp, enabled, isToggleable, callback)
      },

      renderTimeSelects: function () {
        var timeValue = this.model.get('batch_time') || DefaultTime
        var hour = parseInt(timeValue.split(':')[0], 10)
        var currentValue = {
          hour: hour,
          meridian: hour < 12 ? 'am' : 'pm',
          // May want to fetch `Setting#timezone` as a fallback from
          // `batch_timezone`.
          timezone:
            this.model.get('batch_timezone') || window.moment.tz.guess(),
        }

        var callback = function (option) {
          currentValue[option.key] = option.id

          // Hour must be in the range range [1,24]. The logic here -- reset to
          // [1,12] and add 12 if needed -- works for all cases:
          //
          // hour | meridian | result
          // -----|----------|-------
          //    5 | am       | 5
          //   17 | am       | 5
          //    5 | pm       | 17
          //   17 | pm       | 17
          currentValue.hour = currentValue.hour % 12
          if (currentValue.meridian === 'pm') {
            currentValue.hour += 12
          }

          var currentHour = currentValue.hour + ':00'
          this.model.set('batch_time', currentHour)

          var settings = this.model.collection.user.get('user_settings')
          settings.set('batch_approval_emails_time', currentHour)
          settings.set('batch_approval_emails_timezone', currentValue.timezone)

          // We don't currently display a dropdown to change the time zone, so
          // only set the value as a default.
          if (!this.model.get('batch_timezone')) {
            this.model.set('batch_timezone', currentValue.timezone)
          }
        }

        for (var key in TimeSelectOptions) {
          var values = TimeSelectOptions[key]
          var mapper
          if (key === 'hour') {
            mapper = function (value) {
              if (value > 12) {
                value -= 12
              }

              return {
                id: value,
                key: key,
                title: value + ':00',
              }
            }
          } else if (key === 'meridian') {
            mapper = function (value) {
              return {
                id: value,
                key: key,
                title: value.toUpperCase(),
              }
            }
          }
          var options = values.map(mapper)
          var selectedOption = options.find(function (option) {
            var value = currentValue[key]
            if (key === 'hour' && value > 12) {
              value -= 12
            }
            return option.id === value
          })

          this.injectDropdown(this.ui[key], options, selectedOption, callback)
        }
      },

      updateScheduleVisibility: function () {
        // Currently we only let users schedule batch approval emails, since most
        // notifications and email templates (and email delivery code) won't work
        // with batching.
        var type = this.model.get('notification_type')
        var currentState
        if (!isBatchEmailAllowed(type)) {
          currentState = 'disabled'
        } else {
          currentState = this.model.get('notification_email_option')
        }

        var node = this.ui.schedule.get(0)
        EmailStates.filter(function (state) {
          return state !== currentState
        }).forEach(
          function (state) {
            var klass = ScheduleClassPrefix + state
            node.classList.remove(klass)
          }.bind(this)
        )

        node.classList.add(ScheduleClassPrefix + currentState)
      },
    })

    var LoadingPreferences = App.Views.ItemView.extend({
      className: 'notificationPreferences--loader',
      template: _.template(''),
      disableTemplateMagic: true,

      onRender: function () {
        this.injectLoader()
      },

      injectLoader: function () {
        var component = window.React.createElement(window.Kuiper.Loader)
        window.ReactDOM.render(component, this.el)
      },
    })

    var group_template =
      '<h1 class=notificationPreferences--notificationLabel><%= name %></h1> \
  <span class=notificationPreferences--inAppLabel>In-app</span> \
  <span class=notificationPreferences--emailLabel>Email</span> \
  <ul id=js-notificationPreferencesWrapper></ul>'
    var NotificationGroup = App.Views.CompositeView.extend({
      className: 'notificationPreferencesGroup',
      template: _.template(group_template),
      disableTemplateMagic: true,

      childView: PreferenceRow,
      childViewContainer: '#js-notificationPreferencesWrapper',
    })

    var NotificationPreferencesView = App.Views.CollectionView.extend({
      className: 'notificationPreferences',

      childView: NotificationGroup,
      childViewOptions: function (model) {
        return {
          collection: model.get('notification_preferences'),
          model: model,
        }
      },
      emptyView: LoadingPreferences,
    })
  }
)
